import { render, staticRenderFns } from "./CfgAtualizacoesSistema.vue?vue&type=template&id=05830779"
import script from "./CfgAtualizacoesSistema.vue?vue&type=script&lang=js"
export * from "./CfgAtualizacoesSistema.vue?vue&type=script&lang=js"
import style0 from "./CfgAtualizacoesSistema.vue?vue&type=style&index=0&id=05830779&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports